<template>
    <div class="eventlist">
        <div class="etitle">环保事件列表</div>
        <div class="lunbo">
            <div class="table-h">
                <div class="hcol">装置名称</div>
                <div class="hcol">设备名称</div>
                <div class="hcol">类型</div>
                <div class="hcol">发生时间</div>
                <div class="hcol">当前状态</div>
            </div>
            <div class="table-list" ref="tableRef">
                <div class="overflow" :style="{top:topValue + 'px', transition: transition}">
                    <div class="titem" ref="itemRef" v-for="item in tableData" :key="item.id">
                        <div class="frow">{{ item.name }}</div>
                        <div class="frow">{{ item.device }}</div>
                        <div class="frow">{{ item.type }}</div>
                        <div class="frow">{{ item.time }}</div>
                        <div class="frow">{{ item.status }}</div>
                    </div>
                    <div class="temp" v-if="isAnimation">
                        <div class="titem" ref="itemRef" v-for="item in tableData" :key="item.id">
                            <div class="frow">{{ item.name }}</div>
                            <div class="frow">{{ item.device }}</div>
                            <div class="frow">{{ item.type }}</div>
                            <div class="frow">{{ item.time }}</div>
                            <div class="frow">{{ item.status }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            tableData: [
                {
                    name: "锅炉装置s",
                    device: "布袋除尘器-清灰风机",
                    type: "告警",
                    time: "2023-07-02 11:34:25",
                    status: "未处理",
                    id: 1
                },
                {
                    name: "锅炉装置",
                    device: "布袋除尘器-清灰风机",
                    type: "告警",
                    time: "2023-07-02 11:34:25",
                    status: "未处理",
                    id: 2
                },
                {
                    name: "锅炉装置",
                    device: "布袋除尘器-清灰风机",
                    type: "告警",
                    time: "2023-07-02 11:34:25",
                    status: "未处理",
                    id: 3
                },
                {
                    name: "锅炉装置e",
                    device: "布袋除尘器-清灰风机",
                    type: "告警",
                    time: "2023-07-02 11:34:25",
                    status: "未处理",
                    id: 4
                }
            ],
            topValue: 0,
            transition: 'top 0.5s linear',
            tableClientHeight: 0,
            tableItemHeight: 0,
            step: 0,    // 总步数
            current: 0, // 当前所在步数
            timer: null,
            isAnimation: false
        }
    },
    mounted() {
        // 先获取容器大小
        this.resize();
        window.addEventListener("resize", this.resize);
    },
    destroyed() {
        window.removeEventListener("resize", this.resize);
        this.timer && clearInterval(this.timer);
    },
    methods: {
        resize() {
            this.tableClientHeight = this.$refs.tableRef.clientHeight;
            this.tableItemHeight = this.$refs.itemRef[0].clientHeight;
            this.step = this.tableData.length - Math.floor(this.tableClientHeight / this.tableItemHeight);
            if (this.step > 0) {
                this.setIntervalInit();
                this.isAnimation = true;
            } else {
                this.timer && clearInterval(this.timer);
                this.isAnimation = false;
            }
        },
        setIntervalInit() {
            this.timer && clearInterval(this.timer);
            this.timer = setInterval(() => {
                if (this.current < this.tableData.length) {
                    this.move();
                } else {
                    this.transition = "none";
                    this.topValue = 0;
                    this.current = 0;
                    setTimeout(() => {
                        this.move()
                    }, 30)
                }
            }, 1000)
        },
        move() {
            this.topValue -= this.tableItemHeight;
            this.transition = "top 0.5s linear";
            this.current ++;
        }
    }
}
</script>
<style lang="scss" scoped>
.eventlist {
    background: url(../../../assets/newscreen/bg_list.png) no-repeat;
    background-size: 104% 104%;
    background-position: center;
    width: 100%;
    height: 100%;
    position: relative;
    padding: 2rem 1rem;
    .etitle {
        font-size: 1rem;
        color: #F5FAFF;
        letter-spacing: 0;
        text-shadow: 0 0 0.25rem #44D7B6;
        font-weight: 600;
        position: absolute;
        left: 50%;
        top: 0.75rem;
        transform: translateX(-50%);
    }
    .lunbo {
        font-size: 0.875rem;
        line-height: 2.25rem;
        width: 100%;
        height: 100%;
        .table-h {
            display: grid;
            grid-template-columns: 0.25fr 0.25fr 0.25fr 0.25fr 0.25fr;
            color: #fff;//2333;
        }
        .table-list {
            height: calc(100% - 2.25rem);
            color: #F5FAFF;
            overflow: hidden;
            position: relative;
            .overflow {
                width: 100%;
                position: absolute;
                top: 0;
                left: 0;
            }
            .titem {
                display: grid;
                grid-template-columns: 0.25fr 0.25fr 0.25fr 0.25fr 0.25fr;
            }
            .titem:hover {
                background: rgba(0,237,243,0.10);
            }
        }
        .hcol,.frow {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
}
</style>